import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';
import { MarkdownContent } from '../components/MarkdownContent';
import privacyPolicy from '../content/legal/privacy-policy.md?raw';
import termsOfService from '../content/legal/terms-of-service.md?raw';

type PublicDocument = 'privacy' | 'terms';

const DOCUMENTS: Record<PublicDocument, { title: string; content: string }> = {
  privacy: { title: 'Privacy Policy', content: privacyPolicy },
  terms: { title: 'Terms of Service', content: termsOfService },
};

function withoutMarkdownTitle(content: string): string {
  return content.replace(/^# .+\r?\n+/, '');
}

export default function PublicInformationScreen({ document }: { document: PublicDocument }) {
  const navigate = useNavigate();
  const selected = DOCUMENTS[document];

  return (
    <main className="size-full overflow-y-auto pb-16" style={{ background: 'var(--app-bg)' }}>
      <header className="app-screen-header px-5 pb-3">
        <button
          type="button"
          aria-label="Go back"
          onClick={() => navigate(-1)}
          className="size-10 rounded-full flex items-center justify-center"
          style={{ background: 'var(--app-surface)', color: 'var(--app-text)' }}
        >
          <ArrowLeft className="size-5" aria-hidden="true" />
        </button>
      </header>
      <article className="px-5">
        <h1 className="text-3xl tracking-tight mb-6" style={{ color: 'var(--app-text)' }}>
          {selected.title}
        </h1>
        <MarkdownContent content={withoutMarkdownTitle(selected.content)} />
      </article>
    </main>
  );
}
